// router.js
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from './views/Home.vue';
import Result from './views/Result.vue';
import Login from './views/Login.vue';
import Print from './views/Print.vue';
import VhwcXcvGudGT from './views/VhwcXcvGudGT.vue';
import store from './store'; // 导入Vuex Store
Vue.use(VueRouter);

const

  routes = [{
      path: '/',
      component: Home,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/Result',
      component: Result,
      meta: {
        requiresAuth: true
      },
    },
    {
      name: 'Print',
      path: '/Print',
      component: Print,
    },
    {
      name: 'VhwcXcvGudGT',
      path: '/VhwcXcvGudGT',
      component: VhwcXcvGudGT,
    },
    {
      name: 'Login',
      path: '/Login',
      component: Login,
    },
  ];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 检查用户是否已登录（这里假设你已经在store中存储了用户登录状态）
  const isUserLoggedIn = localStorage.getItem('token');
  if (to.meta.requiresAuth && !isUserLoggedIn) { // 判断目标路由是否要求身份验证
    // 用户未登录且目标路由需要身份验证，则重定向到登录页
    next({
      path: '/Login',
      query: {
        redirect: to.fullPath
      }
    });
  } else {
    // 用户已登录或目标路由不需要身份验证时继续导航
    next();
  }

  // 或者，如果你要检查后端返回的状态码并据此进行处理：
  // ...
  // 在这里发起一个异步请求来检查用户的会话状态
  // axios.get('/api/check-session')
  //   .then(response => {
  //     if (!response.data.isAuthenticated) {
  //       next({ name: 'Login', query: { redirect: to.fullPath } });
  //     } else {
  //       next();
  //     }
  //   })
  //   .catch(() => {
  //     next({ name: 'Login', query: { redirect: to.fullPath } });
  //   });
});
export default router;